export type ThemeChoice = 'system' | 'light' | 'dark';
const KEY = 'vardex.theme';

export function storedTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

const media = () => window.matchMedia('(prefers-color-scheme: dark)');

export function resolvedTheme(choice: ThemeChoice): 'light' | 'dark' {
  return choice === 'system' ? (media().matches ? 'dark' : 'light') : choice;
}

export function applyTheme(choice: ThemeChoice): void {
  document.documentElement.dataset.theme = resolvedTheme(choice);
}

export function saveTheme(choice: ThemeChoice): void {
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // private mode: the choice lasts until reload
  }
  applyTheme(choice);
  window.dispatchEvent(new Event('vardex-theme'));
}

/** Follow the OS while the choice is "system". */
export function watchSystemTheme(): () => void {
  const onChange = () => {
    if (storedTheme() === 'system') {
      applyTheme('system');
      window.dispatchEvent(new Event('vardex-theme'));
    }
  };
  const m = media();
  m.addEventListener('change', onChange);
  return () => m.removeEventListener('change', onChange);
}
